// extracted by mini-css-extract-plugin
export var collapsedSummary = "_it-0";